<template>
  <t-email-attachment
    v-for="attachment in attachments"
    :key="attachment.id"
    class="tw-w-[165px]"
    test-id="incident-attachment-download-link"
  >
    <template #name>
      <div
        v-tippy="{
          content: attachment.name,
          placement: 'top',
          maxWidth: 'none',
        }"
        class="tw-overflow-hidden tw-text-ellipsis"
      >
        {{ attachment.name }}
      </div>
    </template>
    <template #extension>
      <div
        v-tippy="{
          content: attachment.content_type,
          placement: 'bottom',
          maxWidth: 'none',
        }"
        class="tw-text-nowrap tw-overflow-hidden tw-text-ellipsis"
      >
        {{ attachment.content_type }}
      </div>
    </template>
    <template #size>
      {{ formatBytes(attachment.size) }}
    </template>
  </t-email-attachment>
</template>

<script setup lang="ts">
import { formatBytes } from "@/utils/formatBytes";
import TEmailAttachment from "@/components/TEmailAttachment/TEmailAttachment.vue";
import { IncidentDetailsAttachment } from "@/modules/PhishTitan/types/IncidentSummary";

defineProps<{ attachments: IncidentDetailsAttachment[] }>();
</script>
